module.exports = __webpack_public_path__ + "static/media/Login-signup.0eb2d81b.png";